export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/PL-5382948f10392d56aa84a9ceec247cec.png";